<template>
  <div
    class="relative overflow-hidden rounded-2xl p-5 bg-gradient-to-br from-pink-500 via-purple-600 to-violet-600 text-white shadow-xl shadow-purple-500/30"
    dir="rtl"
  >
    <!-- Decorative glow -->
    <div class="absolute -top-10 -right-10 w-32 h-32 bg-white/10 rounded-full blur-2xl" />
    <div class="absolute -bottom-10 -left-10 w-32 h-32 bg-white/10 rounded-full blur-2xl" />

    <div class="relative">
      <div class="flex items-center gap-2 mb-2">
        <div class="w-8 h-8 bg-white/20 backdrop-blur rounded-lg flex items-center justify-center">
          <Globe class="w-4 h-4" />
        </div>
        <span class="text-xs font-semibold opacity-90">האתר שלכם מוכן! 🎉</span>
      </div>

      <p class="text-sm leading-relaxed opacity-95 mb-3">
        זה הקישור לאתר ההזמנות שלכם. שתפו אותו עם לקוחות כדי שיוכלו לקבוע תור.
      </p>

      <!-- URL row -->
      <div
        class="bg-white/15 backdrop-blur rounded-xl px-3 py-2.5 mb-3 flex items-center gap-2 border border-white/20"
        dir="ltr"
      >
        <Link2 class="w-4 h-4 flex-shrink-0 opacity-80" />
        <span class="text-xs font-mono truncate flex-1">{{ displayUrl }}</span>
      </div>

      <!-- Actions -->
      <div class="flex gap-2">
        <button
          class="flex-1 bg-white text-purple-700 font-semibold text-sm py-2.5 rounded-xl hover:bg-purple-50 transition-colors flex items-center justify-center gap-1.5"
          @click="copyLink"
        >
          <Copy class="w-4 h-4" />
          {{ copied ? 'הועתק!' : 'העתק' }}
        </button>
        <button
          class="flex-1 bg-white/20 backdrop-blur border border-white/30 text-white font-semibold text-sm py-2.5 rounded-xl hover:bg-white/30 transition-colors flex items-center justify-center gap-1.5"
          @click="openLink"
        >
          <ExternalLink class="w-4 h-4" />
          פתח
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { Globe, Link2, Copy, ExternalLink } from 'lucide-vue-next';
import { useToast } from 'vue-toastification';
import { Capacitor } from '@capacitor/core';
import { Clipboard } from '@capacitor/clipboard';
import { openLinkNewTab } from '@torim-app/utils';

const props = defineProps<{
  url: string;
}>();

const toast = useToast();
const copied = ref(false);

const displayUrl = computed(() => props.url.replace(/^https?:\/\//, ''));

const copyLink = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      await Clipboard.write({ string: props.url });
    } else {
      await navigator.clipboard.writeText(props.url);
    }
    copied.value = true;
    toast.success('הקישור הועתק בהצלחה 😃');
    setTimeout(() => (copied.value = false), 2000);
  } catch {
    toast.error('לא הצלחנו להעתיק');
  }
};

const openLink = () => {
  openLinkNewTab(props.url);
};
</script>
